import { FC, useCallback } from 'react';
import { RoyaltyCheckLineItemsTable } from '../shared/royalty-check-line-items-table';
import styles from './royalty-checks-content.module.scss';

const EXPANSION_PAGE_SIZE = 10;

interface Props {
  parentId: string;
}

const RoyaltyCheckLineItemsExpansion: FC<Props> = ({ parentId }) => (
  <RoyaltyCheckLineItemsTable
    royaltyCheckId={parentId}
    persistenceKey={`royalty-check-${parentId}-li-expansion`}
    initialPageSize={EXPANSION_PAGE_SIZE}
    className={styles.expanded}
    renderEmpty={
      <p className={styles.emptyExpanded}>
        No line items on this royalty check.
      </p>
    }
  />
);

export const useRoyaltyCheckRowSubComponent = <
  TRow extends { id?: string },
>() => {
  return useCallback(
    (row: { original: TRow }) => (
      <RoyaltyCheckLineItemsExpansion parentId={String(row.original.id)} />
    ),
    []
  );
};

export { RoyaltyCheckLineItemsExpansion };
